var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.order_status.name != 'Cancelado' && _vm.model.order_status.name != 'Entregado')?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('cancel-order'),expression:"'cancel-order'"}],attrs:{"block":"","variant":"danger"}},[_vm._v(" Cancelar pedido ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }